var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206 40.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5d3233;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0C8.75,3.17,17.32,6,25.93,8.41s17.16,4.65,25.75,6.39a268.56,268.56,0,0,0,51.49,5.69,242.55,242.55,0,0,0,25.7-1.22c2.13-.25,4.27-.5,6.42-.72s4.26-.65,6.4-1l3.21-.46,3.19-.63,6.41-1.2c2.11-.53,4.24-1,6.38-1.47,1.07-.25,2.15-.47,3.21-.73s2.12-.58,3.18-.87c2.13-.55,4.26-1.14,6.42-1.68l6.37-2,3.24-.94c1.09-.29,2.11-.73,3.19-1.07,2.13-.7,4.26-1.44,6.44-2.12L194.57,4l1.6-.59,3.22-1.16C201.56,1.45,203.75.68,206,0c-1.64,1.65-3.34,3.22-5.06,4.8S197.5,8,195.62,9.35a129.65,129.65,0,0,1-11.4,8.16l-6,3.71c-2.06,1.12-4.16,2.19-6.25,3.29-1.05.54-2.09,1.1-3.15,1.63s-2.16.95-3.24,1.42c-2.17.94-4.34,1.91-6.54,2.8s-4.47,1.59-6.71,2.38l-3.39,1.15-3.44,1c-2.3.61-4.59,1.29-6.92,1.81s-4.68,1-7,1.42A155.35,155.35,0,0,1,103,40.48,159.88,159.88,0,0,1,47.22,29.82,152.55,152.55,0,0,1,22,17.34a127.24,127.24,0,0,1-11.54-8A81.75,81.75,0,0,1,0,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.1f694b96.svg";
export { ForwardRef as ReactComponent };